// Copyright (c) 2017 Deere & Company

import './pip-code-request.scss';
import React, {Component, PropTypes} from 'react';
import Customer from '@deere/cps-it.warranty-model-factory/lib/customer';
import {FormattedMessage} from 'react-intl';
import KeyValuePair from '@deere/cps-it.warranty-model-factory/lib/key-value-pair';
import PipCode from '@deere/cps-it.warranty-model-factory/lib/pip-code';
import PipCodeDetails from './pip-code-details';
import PipDetails from './pip-product-details/pip-details';
import PipProduct from '@deere/cps-it.warranty-model-factory/lib/pip-product';
import PipProductDetails from './pip-product-details/pip-product-details';
import WarrantyLoadingIndicator from '../../../shared/components/warranty-loading-indicator';

function handleCancel() {

    this.actions.goToPreviousView();

}

function handleSubmit() {

    this.actions.createPipCodeRequest();

}

function handleItemChange(name, data) {

    this.actions.updatePipCodeObject(name, data);
    this.actions.updateFormValidation();

}

function handleFileDelete(file) {

    this.actions.deleteFileRequest(file);

}

function handleFileUploadSuccess(file) {

    this.actions.updatePipCodeObject('addFile', file);

}

class PipCodeRequest extends Component {

    componentWillMount() {

        this.props.actions.readPipProduct(this.props.routeParams.id);
        this.props.actions.readPipCodeType();

    }

    componentWillUnmount() {

        this.props.actions.resetPipCode();
        this.props.actions.resetCustomer();
        this.props.actions.resetPipProduct();
        this.props.actions.updateFormVisibility(false);

    }

    render() {

        return (
            <div className='pip-code-request'>
                <WarrantyLoadingIndicator isLoading={this.props.busyCounter > 0}/>
                <header>
                    <h2>
                        <FormattedMessage id='PIP_CODE_REQUEST'/>
                    </h2>
                    <section className='button-group'>
                        <button
                            className='cancel'
                            onClick={this.props::handleCancel}
                        >
                            <FormattedMessage id='CANCEL'/>
                        </button>
                        <button
                            className='submit'
                            disabled={!this.props.isFormValid}
                            onClick={this.props::handleSubmit}
                        >
                            <FormattedMessage id='SUBMIT'/>
                        </button>
                    </section>
                </header>
                <PipDetails pipProduct={this.props.pipProduct}/>
                <PipProductDetails pipProduct={this.props.pipProduct}/>
                {this.props.isFormVisible &&
                    <PipCodeDetails
                        customer={this.props.customer}
                        handleFileDelete={this.props::handleFileDelete}
                        handleFileUploadSuccess={this.props::handleFileUploadSuccess}
                        onItemChange={this.props::handleItemChange}
                        onPipCodeChange={this.props::handleItemChange}
                        pipCode={this.props.pipCode}
                        pipCodeType={this.props.pipCodeType}
                        pipProduct={this.props.pipProduct}
                    />
                }
            </div>
        );

    }

}

PipCodeRequest.displayName = 'PipCodeRequest';
PipCodeRequest.propTypes = {
    actions: PropTypes.object.isRequired,
    busyCounter: PropTypes.number.isRequired,
    customer: PropTypes.instanceOf(Customer).isRequired,
    isFormValid: PropTypes.bool.isRequired,
    isFormVisible: PropTypes.bool.isRequired,
    pipCode: PropTypes.instanceOf(PipCode).isRequired,
    pipCodeType: PropTypes.arrayOf(PropTypes.instanceOf(KeyValuePair)).isRequired,
    pipProduct: PropTypes.instanceOf(PipProduct).isRequired,
    routeParams: PropTypes.object.isRequired
};

export default PipCodeRequest;



// WEBPACK FOOTER //
// ./src/pip/pip-code/components/pip-code-request.js